/** Shared async helpers. */

/** Resolve after ms milliseconds — e.g. backoff between retries. */
export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
